import { render, staticRenderFns } from "./ChicksByPostura.vue?vue&type=template&id=10b82cda"
import script from "./ChicksByPostura.vue?vue&type=script&lang=js"
export * from "./ChicksByPostura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports